import { render, staticRenderFns } from "./DPlayerSettingItem.vue?vue&type=template&id=40829ffa&scoped=true&"
import script from "./DPlayerSettingItem.vue?vue&type=script&lang=js&"
export * from "./DPlayerSettingItem.vue?vue&type=script&lang=js&"
import style0 from "./DPlayerSettingItem.vue?vue&type=style&index=0&id=40829ffa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40829ffa",
  null
  
)

export default component.exports